// extracted by mini-css-extract-plugin
module.exports = {"container":"OOSRequest_container_3h0sp","containerGrid2":"OOSRequest_containerGrid2_V5CZf"};